// CRM-4757
export const useTriggerEvent = () => {
    const on = (event, parameters = {}) => {
        if (typeof FS === "function") {
            FS("trackEvent", {
                name: event.name,
                properties: parameters ?? {},
            });
        }
    };

    return {
        on,
    };
};
